import * as React from "react";
const SvgPlay = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.3681 7.6758C14.7193 8.43587 15.3949 8.81591 15.62 9.31529C15.8162 9.75068 15.8162 10.2493 15.62 10.6847C15.3949 11.1841 14.7193 11.5641 13.3681 12.3242L8.14069 15.2646C6.83433 15.9994 6.18115 16.3669 5.64612 16.3064C5.17935 16.2536 4.75652 16.0063 4.48169 15.6254C4.16667 15.1887 4.16667 14.4393 4.16667 12.9404V7.05959C4.16667 5.56074 4.16667 4.81131 4.48169 4.37464C4.75652 3.99369 5.17935 3.74639 5.64612 3.69363C6.18115 3.63315 6.83433 4.00056 8.1407 4.73539L13.3681 7.6758Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgPlay;
